import { BehaviorSubject, Observable, Subscription } from 'rxjs';

export abstract class ConnectServiceBase {
  public streamTime: number = 0;
  protected timerSubscription: Subscription | null = null;
  protected streamTimeSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  public streamTime$: Observable<string | null> = this.streamTimeSubject.asObservable();
  protected totalSecondsSubject: BehaviorSubject<number | null> = new BehaviorSubject<number | null>(null);
  public totalSeconds$: Observable<number | null> = this.totalSecondsSubject.asObservable();

  protected formatTime(hours: number, minutes: number, seconds: number): string {
    const pad = (num: number): string => num.toString().padStart(2, '0');

    return (hours > 0)
      ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
      : `${pad(minutes)}:${pad(seconds)}`;
  }

  public clearTimer(): void {
    this.streamTime = 0;
    this.streamTimeSubject.next(null);

    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
      this.timerSubscription = null;
    }
  }
}
